import { PLATFORM_API_URL } from '../constants';
import { del, get, getPublic, patch, post } from '../requestMethods';
import {
  CompositionsResponse,
  PaginatedRecordingsResponse,
  Recording,
  RecordingEditorDataResponse,
  RecordingRenderRequest,
  RecordingRenderResponse,
  RecordingRetryResponse,
  RecordingSharedSchema,
  RecordingSharingResponse,
} from './types';

const URL = `${PLATFORM_API_URL}/api/recording/v1/recordings`;

export const RECORDING_API = {
  batchDeleteRecordings: (recordingIds: string[]) =>
    post<{ deleted_count: number }>(`${URL}/batch-delete`, { data: { recording_ids: recordingIds } }),
  retryRecording: (id: string) => post<RecordingRetryResponse>(`${URL}/${id}/retry`),
  shareRecording: (id: string) => post<RecordingSharingResponse>(`${URL}/${id}/share`),
  startRecordingRender: (id: string, data: RecordingRenderRequest) =>
    post<RecordingRenderResponse>(`${URL}/${id}/render`, { data }),
  deleteRecording: (id: string) => del<void>(`${URL}/${id}`),
  getCompositions: (id: string) => get<CompositionsResponse>(`${URL}/${id}/compositions`),
  getRecording: (id: string) => get<Recording>(`${URL}/${id}`),
  getRecordingEditorData: (id: string) => get<RecordingEditorDataResponse>(`${URL}/${id}/editor-data`),
  getRecordings: (limit = 100, offset = 0) =>
    get<PaginatedRecordingsResponse>(`${URL}/`, {
      params: { limit, offset },
    }),
  getSharedRecording: ({ sharing_id }: { sharing_id: string }) =>
    getPublic<RecordingSharedSchema>(`${URL}/shared/${sharing_id}`),
  updateRecording: (id: string, data: { title: string }) =>
    patch<Recording>(`${URL}/${id}`, { data }),
};
